import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/entities')({
  staticData: { breadcrumb: 'Legal Entities', breadcrumbKey: 'K_BREADCRUMB_ENTITIES' },
  component: EntitiesLayout,
});

function EntitiesLayout() {
  return <Outlet />;
}
